import styled from 'styled-components';
import footer_iecas from '../../statics/footer_iecas.jpg'
import footer_cas from '../../statics/footer_cas.jpg'
import footer_icd from '../../statics/footer_icd.jpg'
import footer_last from '../../statics/footer_last.jpg'

export const LogoWrapper = styled.div`
height:120px;
box-sizing:border-box;
padding-top:25px;
min-width:1270px;
`

export const IecasImag = styled.a`
position:relative;
padding-top:10px;
display: inline-block;block;
width: 21%;
height: 61%;
background:url(${footer_iecas});
background-repeat: no-repeat;
background-position: center;
background-size:contain;
`

export const CasImag = styled.a`
position:relative;
padding-top:10px;
display: inline-block;
width: 22%;
height: 63%;
background:url(${footer_cas});
background-repeat: no-repeat;
background-position: center;
background-size:contain;
`

export const IcdImag = styled.a`
position:relative;
padding-top:10px;
display: inline-block;
width: 20%;
height: 56%;
background:url(${footer_icd});
background-repeat: no-repeat;
background-position: center;
background-size:contain;
`

export const LastImag = styled.a`
position:relative;
padding-top:10px;
display: inline-block;
width: 21%;
height: 62%;
background:url(${footer_last});
background-repeat: no-repeat;
background-position: center;
background-size:contain;
`